import { useState, useCallback } from 'react'
import { type FormConfig } from './types'

export const useFieldsDirty = (config: FormConfig) => {
    const defaultState = Object.keys(config).reduce((acc, fieldName) => {
        return Object.assign({}, acc, { [fieldName]: false })
    }, {})

    const [fieldsDirty, setFieldsDirty] =
        useState<Record<string, boolean>>(defaultState)

    const isFieldDirty = useCallback(
        (fieldName: string) => {
            return fieldsDirty[fieldName]
        },
        [fieldsDirty]
    )

    const setFieldDirty = useCallback(
        (fieldName: string, isDirty: boolean) => {
            setFieldsDirty(
                Object.assign({}, fieldsDirty, { [fieldName]: isDirty })
            )
        },
        [fieldsDirty]
    )

    const setAllFieldsDirty = useCallback(() => {
        const newFieldsDitry = Object.keys(config).reduce((acc, fieldName) => {
            return Object.assign({}, acc, { [fieldName]: true })
        }, {})
        setFieldsDirty(newFieldsDitry)
    }, [config])

    const resetFieldsDirty = () => {
        setFieldsDirty(defaultState)
    }

    return { isFieldDirty, setFieldDirty, setAllFieldsDirty, resetFieldsDirty }
}
